const languages = [
  {
    name: "Python",
    proficiency: 100,
  },
  {
    name: "Java",
    proficiency: 100,
  },
  {
    name: "C",
    proficiency: 90,
  },
  {
    name: "C++",
    proficiency: 75,
  },
  {
    name: "Haskell",
    proficiency: 70,
  },
];

const languageDetails = [
  {
    name: 'Java',
    small: '10+',
    large: '3'
  },
  {
    name: 'Python',
    small: '10+',
    large: '3'
  },
  {
    name: 'C',
    small: '5',
    large: '2'
  },
  {
    name: 'C#',
    small: '6',
    large: '1'
  },
  {
    name: 'Javascript',
    small: '6',
    large: '2'
  }
];

const languageExtra = ['Haskell', 'Kotlin', 'Go', 'SQL', 'Bash', '...'];

const frameworks = [
  'Tensorflow', 'Keras', 'TFX', 'Jax', 'Flax', 'PyTorch', 'PyData Stack', 'Django', 'Flask',
  'ExpressJS', 'Postgres', 'MongoDB', 'Unity', 'React', '.NET', 'Android SDK'
];

const Skills = {
  languages: languages,
  languageDetails: languageDetails,
  languageExtra: languageExtra,
  frameworks: frameworks
}

export default Skills;